export const SERVICE_OFFERS = [
  { name: 'Webs', example: 'Landings, marca personal, corporativas y blog' },
  { name: 'Tiendas', example: 'Catálogo, pagos con Stripe y pedidos' },
  { name: 'Automatizaciones', example: 'Emails, CRM, N8N y facturas' },
  { name: 'Bases de datos', example: 'Clientes, inventario, paneles e informes' },
  { name: 'Apps y paneles', example: 'Dashboards, flujos de equipo y backoffice' },
  { name: 'Integraciones', example: 'APIs, Google, pagos y lo que necesites' },
  { name: 'Mantenimiento', example: 'Actualizaciones, correcciones y optimizaciones' },
  { name: 'Algo muy concreto', example: 'Desarrollo o funcionalidad totalmente personalizada' },
] as const;

export const CALENDAR_URL = 'https://calendar.app.google/3TMX3h7SGT1wkdp87';
export const CONTACT_EMAIL = 'soporte@alejandrosn.com';
export const CONTACT_ADDRESS_LINE = 'Calle Felipe Sanclemente 8, 4B, 50001, Zaragoza';
export const CONTACT_MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(CONTACT_ADDRESS_LINE)}`;
export const CONTACT_HOURS_OPEN = 'Lunes a viernes, 08–18 h';
export const CONTACT_HOURS_CLOSED = 'Sábados y domingos, cerrado';

/**
 * Teléfono público para llamadas y extensiones de Google Ads.
 * E.164. `VITE_PUBLIC_PHONE` lo sustituye si está definido.
 */
export const PUBLIC_PHONE = (import.meta.env.VITE_PUBLIC_PHONE ?? '').trim() || '+34623761369';

export function phoneTelHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, '')}`;
}

export function formatPhone(phone: string): string {
  const compact = phone.replace(/[^\d+]/g, '');
  const spain = compact.match(/^\+34(\d{9})$/);
  if (!spain) return phone.trim();
  const digits = spain[1];
  return `${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 7)} ${digits.slice(7)}`;
}
